/**
 * ETML
 * @ De: Theo Bensaci
 * @ Date: 15:58 20.04.2023
 * @ Description: button pour le mots
 */

import "./index.css";
import React from 'react';
import Word from "../../GameClass/word";

class WordButton extends React.Component {
  constructor(props) {
    super(props);
    this.self=React.createRef();


    // add Word
    this.word=props.word;
    if(this.word==undefined){
        this.word=new Word(props.text,props.startPos,props.endPos);
    }

    this.sentence=props.sentence;       // (class Sentence) sentence qui posède le mot
    
    this.select=props.select;
    this.disabel=props.disabel;

    this.endState=props.endState;        // state de fin du boutton, 0 = correct, 1 = faux, 2 = miss, default = none

    this.state={
        className:this.getNewClassname()
    };

    // function aditionelle lors que le button est présé
    this.onButtonClick=props.onClick;

    this.fontSize=(props.fontSize!=undefined)?props.fontSize:20;

  }

  /**
   * onbutton click
   * @param {element} me élmenet qui a applé la fonction 
   * @returns none
   */
  onClick(me){
    let self=me;
    if(self.disabel || self.endState!=undefined)return;

    self.select=!self.select;
    self.setState({
        className:this.getNewClassname()
    });

    // ajoute ou enlèvle le mots des reponce du joueur
    if(self.sentence!=undefined){
        if(self.select){
            self.sentence.addAnswerWord(self.word);
        }
        else{
            self.sentence.removeAnswerWord(self.word);
        }
    }

    if(self.onButtonClick!=null)self.onButtonClick();
  }


  /**
   * Donne la class actuel du button
   * @returns string
   */
  getNewClassname(){
    let baseClassName="WordButton";

    if(this.select){
        return baseClassName+" WordButton-Select";
    }

    if(this.endState!=undefined){
        switch(this.endState){
            case 0:
                return baseClassName+" WordButton-Correct";
            case 1:
                return baseClassName+" WordButton-Error";
            case 2:
                return baseClassName+" WordButton-None";
            default:
                return baseClassName;
        }
    }

    if(this.disabel){
        return baseClassName+" WordButton-Disabel";
    }

    return baseClassName+" WordButton-Default";
  }

  render() {
    return (
        <button ref={this.self} className={this.state.className} style={{fontSize:this.fontSize}} onClick={()=>{this.onClick(this);}}>
            {this.word.text}
        </button>
    );
  }
}

export default WordButton;
